import { useEffect, useState } from 'react';
import CollectionModel from './CollectionsModel';
import Breadcrumbs from '../../layout/Breadcrumbs';
import { useDispatch, useSelector } from 'react-redux';
import { getCompanyDetails, fetchAllCompanies } from '../../company/store/company.actions';
import { selectAuthUser } from '../../auth/store/auth.selectors';
import { selectAllCollectionsStatus } from '../store/collection.selectors';
import { fetchAllCollections, resetCollection } from '../store/collection.actions';
import { selectedCompanyID, selectedCompanyDetails } from '../../company/store/company.selectors';
import { Box, Snackbar, Alert } from '@mui/material';
import { ContentContainer } from '../../../utils/common/styles/commonStyles';
import AddCollectionModal from './AddCollection';
import SearchHeader from '../components/SearchHeader';

const Collection = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuthUser);
  const status = useSelector(selectAllCollectionsStatus);

  const selectedCompID = useSelector(selectedCompanyID);
  const companyDetails = useSelector(selectedCompanyDetails);

  const currentRoleId = Number(
    user?.roleID ||
      user?.roleId ||
      user?.roleid ||
      JSON.parse(localStorage.getItem('user') || '{}')?.roleid
  );
  const shouldShowBreadcrumbs = [1, 2, 3].includes(currentRoleId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [subscriptionExpired, setSubscriptionExpired] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'warning',
  });

  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Collections', path: '/collections' },
  ];

  useEffect(() => {
    if (selectedCompID) dispatch(getCompanyDetails(selectedCompID));
    else dispatch(getCompanyDetails(user.companyid));
  }, []);

  // determine if subscription has expired once details arrive
  useEffect(() => {
    if (companyDetails && companyDetails.subscriptionEndDate) {
      const end = new Date(companyDetails.subscriptionEndDate);
      const now = new Date();
      setSubscriptionExpired(end <= now);
    }
  }, [companyDetails]);

  useEffect(() => {
    localStorage.removeItem('selectedDriveRow');
    if (subscriptionExpired) {
      setSnackbar({
        open: true,
        message:
          'Your subscription has ended. Kindly make the payment to extend your subscription.',
        severity: 'warning',
      });
    }
  }, [subscriptionExpired]);

  useEffect(() => {
    if (status === 'idle' && !subscriptionExpired) {
      const companyid = JSON.parse(localStorage.getItem('user')).companyid;
      dispatch(fetchAllCollections(companyid));
      dispatch(fetchAllCompanies());
    }
  }, [status, subscriptionExpired]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    dispatch(resetCollection());
    setIsModalOpen(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box>
      {shouldShowBreadcrumbs && <Breadcrumbs items={breadcrumbItems} />}

      <ContentContainer>
        <SearchHeader
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          handleOpenModal={handleOpenModal}
        />
        {/* Table Section */}
        <CollectionModel handleOpenModal={handleOpenModal} searchTerm={searchTerm} />

        <AddCollectionModal open={isModalOpen} handleClose={handleCloseModal} />
      </ContentContainer>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Collection;
